"use strict";

exports.__esModule = true;
var _CalendarRoutes = require("./CalendarRoutes");
Object.keys(_CalendarRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CalendarRoutes[key]) return;
  exports[key] = _CalendarRoutes[key];
});